import { apiGet } from "./client.js";
import webApi from "./webApi.js";

export const getHomeAutoservicioPage = (locale) =>
  apiGet(`/content/homepage-autoservicio?locale=${encodeURIComponent(locale)}`);

export const getSponsorAutoservicePage = (locale) =>
  apiGet(`/content/sponsor-autoservice?locale=${encodeURIComponent(locale)}`);

export const getImportDataPage = (locale) =>
  apiGet(`/content/import-data?locale=${encodeURIComponent(locale)}`);

export const getBoxPage = (locale) =>
  apiGet(`/content/box?locale=${encodeURIComponent(locale)}`);

export const getEnterStudentPage = (locale) =>
  apiGet(`/content/enter-student?locale=${encodeURIComponent(locale)}`);

export const getEnterTeacherPage = (locale) =>
  apiGet(`/content/enter-docente?locale=${encodeURIComponent(locale)}`);

export const getVerifyPayPage = (locale) =>
  apiGet(`/content/verify-pay?locale=${encodeURIComponent(locale)}`);

export const getPreRegistrationPage = (locale) =>
  apiGet(`/content/pre-registration?locale=${encodeURIComponent(locale)}`);

export const getWithdrawSubjectPage = (locale) =>
  apiGet(`/content/withdraw-subject?locale=${encodeURIComponent(locale)}`);

export const getHomeStudentAutoservicePage = (locale) =>
  apiGet(`/content/homestudent-autoservice?locale=${encodeURIComponent(locale)}`);

export const getEnrolledSubjectPage = (locale) =>
  apiGet(`/content/enrolled-subject?locale=${encodeURIComponent(locale)}`);

export const getBoxStudentPage = (locale) =>
  apiGet(`/content/box-student?locale=${encodeURIComponent(locale)}`);

export const getCalendaryPage = (locale) =>
  apiGet(`/content/calendary?locale=${encodeURIComponent(locale)}`);

export const getAdmissionsMadePage = (locale) =>
  apiGet(`/content/admissions-made?locale=${encodeURIComponent(locale)}`);

export const getReportsPage = (locale) =>
  apiGet(`/content/report-autoservice?locale=${encodeURIComponent(locale)}`);

export const getEnrollmentPage = (locale) =>
  apiGet(`/content/enrollment?locale=${encodeURIComponent(locale)}`);

export const getHomeProfesorAutoservicePage = (locale) =>
  apiGet(`/content/homeprofesor-autoservice?locale=${encodeURIComponent(locale)}`);

export const getCoursesAutoservicePage = (locale) =>
  apiGet(`/content/courses-autoservice?locale=${encodeURIComponent(locale)}`);

export const getNavbarAutoservicePage = (locale) =>
  apiGet(`/content/navbar-autoservice?locale=${encodeURIComponent(locale)}`);

export const getLoginPage = (locale) =>
  apiGet(`/content/login-autoservice?locale=${encodeURIComponent(locale)}`);

export const getSettingsPage = (locale) =>
  apiGet(`/content/setting-autoservice?locale=${encodeURIComponent(locale)}`);

export const getUserHelpPage = (locale) =>
  apiGet(`/content/user-help?locale=${encodeURIComponent(locale)}`);

export const getUserEnrollementPage = (locale) =>
  apiGet(`/content/user-enrollement?locale=${encodeURIComponent(locale)}`);

export const getRegisterNoSubjectsPage = (locale) =>
  apiGet(`/content/register-no-subjects?locale=${encodeURIComponent(locale)}`);

export const getPayPdfPage = (locale) =>
  apiGet(`/content/pay-pdf?locale=${encodeURIComponent(locale)}`);

export const getCommonMessagePage = (locale) =>
  apiGet(`/content/common-message?locale=${encodeURIComponent(locale)}`);

export const getCourseDetailPage = (locale) =>
  apiGet(`/content/course-detail?locale=${encodeURIComponent(locale)}`);

export const getTeacherAttendanceAutoservicePage = (locale) =>
  apiGet(`/content/teacher-attendance-autoservice?locale=${encodeURIComponent(locale)}`);

export const getTeacherGradesAutoservicePage = (locale) =>
  apiGet(`/content/teacher-grades-autoservice?locale=${encodeURIComponent(locale)}`);

export const getGestorTranslationPage = (locale) =>
  apiGet(`/content/gestor-translation?locale=${encodeURIComponent(locale)}`);

// Función para obtener traducciones de pantallas desde la API principal
export const getScreenTranslations = async () => {
  const api = webApi.api();
  const response = await api.get("Traducciones/GetScreenTraductions");
  return response.data;
};

// Función para crear una nueva traducción
export const createTranslation = async (data) => {
  const api = webApi.api();
  const response = await api.post("Traducciones/Create/Traduction/Screen", data);
  return response.data;
};

// Función para actualizar una traducción existente
export const updateTranslation = async (screen, key, traducciones) => {
  const api = webApi.api();
  const response = await api.put(`Traducciones/Update/Traduction/Screen/${screen}/${key}`, {
    traducciones: traducciones
  });
  return response.data;
};

// Función para eliminar una traducción
export const deleteTranslation = async (screen, key) => {
  const api = webApi.api();
  const response = await api.delete(`Traducciones/Delete/Traduction/Key/${screen}/${key}`);
  return response.data;
};